<template>
  <div class="index">
    <!-- 注册 -->
    <div class="box column jBetween aCenter" v-show="zhuce">
      <div class="box-text-zc">{{ title }}</div>
      <div class="box-input">
        <el-input
          placeholder="邮箱地址"
          prefix-icon="el-icon-message"
          v-model="email"
        >
        </el-input>
        <el-input
          placeholder="验证码"
          prefix-icon="el-icon-circle-check"
          v-model="code"
        >
          <div
            slot="append"
            class="getcode"
            @click="getcode"
            :class="{ active: codetext != '获取验证码' }"
          >
            {{ codetext }}
          </div>
        </el-input>
        <el-input
          placeholder="密码"
          show-password
          prefix-icon="el-icon-lock"
          v-model="pass"
        >
        </el-input>
        <el-input
          placeholder="确认密码"
          show-password
          prefix-icon="el-icon-lock"
          v-model="pass2"
        >
        </el-input>
      </div>
      <div class="agree flex aCenter">
        <el-checkbox v-model="agree"></el-checkbox>
        <div class="agree-item">我已阅读并同意</div>
        <div
          class="agree-con"
          @click="(showyhxy = true), (zhuce = false), (logo = 0)"
        >
          粤成商户中心用户协议
        </div>
      </div>

      <div class="btn" @click="registered">{{ zhuceorsure }}</div>
      <div class="agree-con" @click="gologin">使用已有账号登录</div>
    </div>
    <!-- 登录 -->
    <div class="box column jBetween aCenter" v-show="denglu">
      <div class="box-text-zc">登录</div>
      <div class="box-input">
        <el-input
          placeholder="邮箱地址"
          prefix-icon="el-icon-message"
          v-model="email"
        >
        </el-input>
        <el-input
          placeholder="密码"
          show-password
          prefix-icon="el-icon-lock"
          v-model="pass"
        >
        </el-input>
        <div class="flex jBetween login-text">
          <div @click="forgetpass">忘记密码</div>
          <div @click="goregistered">注册</div>
        </div>
      </div>

      <div class="agree flex aCenter">
        <el-checkbox v-model="agree"></el-checkbox>
        <div class="agree-item">我已阅读并同意</div>
        <div
          class="agree-con"
          @click="(showyhxy = true), (denglu = false), (logo = 1)"
        >
          粤成商户中心用户协议
        </div>
      </div>

      <div class="btn" @click="login">登录</div>
    </div>
    <!-- 用户协议 -->
    <div class="yhxy" v-show="showyhxy" @click="isshowyhxy">
      <!-- <div class="yhxy-title">粵成商戶中心用户协议</div> -->
      <div v-html="yonghuxieyi"></div>
    </div>
    <!-- 注册成功 -->
    <div
      v-show="zhucesucc"
      class="box column jBetween aCenter"
      style="height: 600px; width: 600px"
    >
      <img src="../../assets/img/icon_zhucecc.png" alt="" />
      <div class="zccg">恭喜您，注册成功！</div>
      <div class="hysy">欢迎使用粤成商户中心！</div>
      <div class="content">
        欢迎使用粤成商户中心
        我们将引导您开户，您只需完成几个步骤，即可开始投广告。在您使用粤成商户中心的过程中，遇到任何问题可随时咨询您的客户经理或客服人员。您也可以查看粤成学院的课程，了解更多关于广告投放的技巧或最新广告政策。
      </div>
      <div class="tiaozhuan">即将转到粤成商户中心</div>
      <div class="btn-tiaozhuan" @click="gonow">立即跳转</div>
    </div>
  </div>
</template>

<script>
import { getUserAgreeApi } from "../../network/api";
import Index from "./Index";
export default {
  name: "Index",
  mixins: [Index],
  created() {
    getUserAgreeApi()
      .then((res) => {
        this.yonghuxieyi = res.data.data.data;
      })
      .catch();
  },
};
</script>

<style  scoped src="./Index.css">
</style>